import { makeStyles } from "@material-ui/core";

const slotsGeneratorFormStyles = makeStyles(() => ({
  whiteBackground: { marginTop: "12px", backgroundColor: "#E9EFF2 !important" },
  greyBackground: { marginTop: "12px", backgroundColor: "#F9F9F9" },
  error: {
    marginTop: "5px",
    fontSize: "12px",
    color: "red",
  },
  fieldLabel: { marginBottom: "8px" },
  slotsTableLabel: {
    fontWeight: 600,
  },
  orderCutOffHeader: {
    paddingLeft: "24px",
  },
  hideShrinkedLabel: {
    "&.MuiInputLabel-outlined": {
      color: "#B2B2B2",
    },
    "&.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0)",
    },
  },
  selectClass: {
    "&.hasLabel": {
      "& .MuiSelect-root": {
        paddingTop: 16,
        paddingBottom: 14,
      },
    },
  },
  expandedStyle: {
    "&.MuiAccordionSummary-content": {
      "&.Mui-expanded": {
        margin: "0px",
      },
    },
  },
  slotsGeneratorAccordionSummary: {
    padding: "0px 24px",
  },
  daysInput: {
    padding: "8px 0px 16px 0px",
  },
  slotsGeneratorAccordionDetails: {
    padding: "0px 24px",
    display: "block",
  },
  buttons: {
    marginTop: "8px",
    alignItems: "center",
    marginBottom: "12px",
  },
  generateSlotsButton: {
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "10px",
  },
  separation: {
    borderTop: "1px solid #D4D4D4",
    marginBottom: "24px",
  },
  fontSize16: {
    fontSize: "16px",
  },
  slotDays: {
    fontWeight: 600,
    textTransform: "capitalize",
  },
  generatedSlotsTable: {
    margin: "24px 0px",
  },
  slotsGeneratorForm: {
    marginTop: "16px",
    position: "relative",
  },
  dayStyles: {
    fontWeight: 600,
    paddingLeft: "5px",
    textTransform: "capitalize",
  },
  updateSlotButton: {
    justifyContent: "left",
    padding: "0px",
    "&:hover": { backgroundColor: "transparent" },
  },
  iconButton: { cursor: "pointer" },
  rangeHeaderSpanStyle: {
    margin: "0px 0px 8px 0px",
    fontSize: "1rem",
    lineHeight: "23px",
  },
}));

export default slotsGeneratorFormStyles;
